import { adminApiClient } from '../lib/apiClient';

function appendIfPresent(formData, key, value) {
  if (value !== undefined && value !== null && String(value).trim() !== '') {
    formData.append(key, String(value).trim());
  }
}

function extractCategories(payload) {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  if (Array.isArray(payload?.data?.data)) {
    return payload.data.data;
  }

  if (Array.isArray(payload?.data?.categories)) {
    return payload.data.categories;
  }

  if (Array.isArray(payload?.categories)) {
    return payload.categories;
  }

  return [];
}

export async function listAdminCategories() {
  const formData = new FormData();
  const response = await adminApiClient.post('/admin/categories/list', formData);

  return {
    raw: response.data,
    items: extractCategories(response.data),
  };
}

export async function createAdminCategory(payload) {
  const formData = new FormData();

  appendIfPresent(formData, 'name', payload.name);
  appendIfPresent(formData, 'icon', payload.icon);
  appendIfPresent(formData, 'image', payload.image);
  appendIfPresent(formData, 'sort_order', payload.sort_order);

  const response = await adminApiClient.post('/admin/categories/create', formData);
  return response.data;
}

export async function updateAdminCategory(payload) {
  const formData = new FormData();

  appendIfPresent(formData, 'category_id', payload.category_id);
  appendIfPresent(formData, 'name', payload.name);
  appendIfPresent(formData, 'icon', payload.icon);
  appendIfPresent(formData, 'image', payload.image);
  appendIfPresent(formData, 'sort_order', payload.sort_order);

  const response = await adminApiClient.post('/admin/categories/update', formData);
  return response.data;
}

export async function deleteAdminCategory(categoryId) {
  const formData = new FormData();
  appendIfPresent(formData, 'category_id', categoryId);

  const response = await adminApiClient.post('/admin/categories/delete', formData);
  return response.data;
}
